import { useContext } from 'react';

import Button from 'components/common/Button';
import ModalNoFocus from 'components/common/modals/ModalNoFocus';
import { CustomerReportContext } from 'components/grace/Contexts';
import CustomerSupport from 'components/icons/CustomerSupport';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { GENERIC_ERROR, MODAL_TYPES } from 'lib/constants';
import RequestService from 'services/RequestService';

import NavigationHeader from './NavigationHeader';

const HelpInterstitialModal = ({ cs = false }) => {
  const { closeReport, setCurrentModal, setErrorMessage } = useContext(CustomerReportContext);

  const openAda = useAnalyticsCallback(
    async () => {
      const adaGreeting = cs ? window.adaSettings.handoffGreeting : null;
      const onAdaDrawerToggle = isDrawerOpen => {
        if (isDrawerOpen) {
          setCurrentModal('');
        } else {
          setCurrentModal(MODAL_TYPES.help);
          window.adaEmbed.stop();
        }
      };

      const summaryResponse = await RequestService.getGraceSummary();
      if (!summaryResponse.ok) {
        setErrorMessage(GENERIC_ERROR);
        return;
      } else {
        setErrorMessage(null);
      }

      closeReport();

      await window.adaEmbed.start({ ...window.adaSettings, toggleCallback: onAdaDrawerToggle });
      const tokenResponse = await RequestService.getAdaToken();
      await window.adaEmbed.reset({
        greeting: adaGreeting,
        metaFields: {
          ...window.adaSettings.metaFields,
          token: tokenResponse.ok ? tokenResponse.token : '',
          graceHistory: summaryResponse.message,
          graceLiveAgentHandoff: Boolean(cs),
        },
      });
      await window.adaEmbed.toggle();
    },
    ({ events, logEvent }) => {
      logEvent(events.grace.chatInterstitialClicked, {
        cs_option: 'Start A Chat',
      });
    },
    [cs]
  );

  return (
    <ModalNoFocus
      showIcon={false}
      title="Help with something else"
      onDismiss={closeReport}
      bodyPadding="p-0"
      bodyStyle="pb-10"
      explicitBodyStyle={true}
      topBarStyle="hidden"
      explicitTopBarStyle={true}
      mainContentClass="show pointer-events-auto fixed bottom-4 right-4 left-auto w-[384px] max-h-[768px] ml-auto bg-white-100 rounded-t-lg rounded-lg border border-solid border-charcoal-50 shadow-xl"
      explicitMainContentClass={true}
      contentClassname="max-w-sm"
    >
      <NavigationHeader onDismiss={closeReport} helpInterstitial={true} />
      <div className="px-6">
        <CustomerSupport />
        <p className="h2 textPrimary">We'd love to help. Let's chat!</p>
        <p className="textSm mb-6 mt-2">
          Can't find what you need? Our #1 ranked support team is here to help.
        </p>
        <Button className="btn btnPrimary w-full" onClick={openAda}>
          Start a Chat
        </Button>
      </div>
    </ModalNoFocus>
  );
};

HelpInterstitialModal.propTypes = {
  cs: PropTypes.bool,
};

export default HelpInterstitialModal;
